<template>
  <MaxFlexField v-model="context.value.value[props.field.key]" />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

// import { MaxFlexConfig } from '@/apps/brelag/common/models/maxflex/maxflex'
import MaxFlexField from '@/apps/brelag/mandator-user/components/editor/maxflex/MaxFlexField.vue'

import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
